import { render, staticRenderFns } from "./PortalSettingsEditor.vue?vue&type=template&id=566297a2&scoped=true"
import script from "./PortalSettingsEditor.vue?vue&type=script&lang=js"
export * from "./PortalSettingsEditor.vue?vue&type=script&lang=js"
import style0 from "./PortalSettingsEditor.vue?vue&type=style&index=0&id=566297a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566297a2",
  null
  
)

export default component.exports